module.exports = __webpack_public_path__ + "static/img/306.15fc83f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/news/306.png
// module id = 61Ur
// module chunks = 0